import { Play } from "lucide-react";
import { useRef, useState } from "react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const VIDEO_URL = "https://customer-assets.emergentagent.com/job_65cff9e4-1fb7-4087-8c22-d5f62489d89d/artifacts/gje40nz1_video-output-9BC1C1EA-3E3E-4196-A404-DA406AF23EBE-1.mov";

export default function VideoRecap() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [headerRef, headerVisible] = useScrollAnimation({ threshold: 0.2 });
  const [videoContainerRef, videoVisible] = useScrollAnimation({ threshold: 0.15 });

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <section id="video" data-testid="video-recap-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          ref={headerRef}
          className={`text-center mb-10 animate-fade-up ${headerVisible ? 'visible' : ''}`}
        >
          <p className="font-accent text-xl md:text-2xl mb-2" style={{ color: "#7DD4B5" }}>
            Rückblick
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight" style={{ color: "#1F2937" }}>
            Run for Rett 2025
          </h2>
          <div className="section-divider mx-auto mt-4" />
          <p className="text-base md:text-lg mt-4 max-w-2xl mx-auto" style={{ color: "#4B5563" }}>
            Ein unvergesslicher Tag voller Gemeinschaft, Emotion und Hoffnung.
          </p>
        </div>

        <div 
          ref={videoContainerRef}
          className={`relative rounded-2xl overflow-hidden shadow-2xl bg-black aspect-video animate-scale ${videoVisible ? 'visible' : ''}`}
        >
          <video
            ref={videoRef}
            data-testid="recap-video"
            className="w-full h-full object-cover"
            controls={playing}
            playsInline
            preload="metadata"
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            poster=""
          >
            <source src={VIDEO_URL} type="video/quicktime" />
            <source src={VIDEO_URL} type="video/mp4" />
            Dein Browser unterstützt das Video-Element nicht.
          </video>

          {/* Play overlay */}
          {!playing && (
            <button
              data-testid="video-play-btn"
              onClick={handlePlay}
              className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/20 transition-colors group cursor-pointer"
            >
              <div
                className="w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform"
                style={{ background: "rgba(180, 110, 182, 0.9)" }}
              >
                <Play className="w-8 h-8 md:w-10 md:h-10 text-white ml-1" fill="white" />
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
